(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  const scrollToHashCard = () => {
    if (!url.hash) return;
    try {
      const card = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (card) {
        try {
          card.scrollIntoView({ behavior: 'auto', block: 'nearest' });
        } catch (error) {
          card.scrollIntoView(false);
        }
      }
    } catch (error) {
      return;
    }
  };
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      scrollToHashCard,
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
